import React, { useRef, useState } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { handleStatus } from "../../helperFunctions/helpers";
import { buildName, buildNameWithId, Singleton } from "helper/tools";
import BadgeStatus from "../Asociados/BadgeStatus";
import { format, parseISO } from "date-fns";
import CreditLevelActionsModal from "../LimitLevels/CreditLevelActionsModal";

export default function NotificacionesTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
  reload,
}) {
  const creditLevelActionsModalRef = useRef();

  const theadRef = useRef();

  const [item, setItem] = useState({});

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  const tryApprove1 = async (newItem) => {
    /*let response = await pagoniApproveResetPassword(item.username).catch(
      (e) => {}
    );
    if (!response) return;
    fetchData();*/

    setItem(newItem);
    creditLevelActionsModalRef.current.toggleModal();

    console.log("-->");
  };

  return (
    <>
      <CreditLevelActionsModal
        ref={creditLevelActionsModalRef}
        item={item}
        reloadCredit={reload}
      />
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="fecha"
              style={{ width: "200px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Fecha
            </th>

            <th
              scope="col"
              data-column="id"
              style={{ verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Orden de Venta
            </th>
            <th
              scope="col"
              data-column="AsociadoId"
              style={{ verticalAlign: "middle", width: "150px" }}
              onClick={(event) => handleSort(event)}
            >
              Tipo
            </th>
            <th
              rowSpan={2}
              scope="col"
              className="no-sort"
              style={{
                width: "150px",
                verticalAlign: "middle",
              }}
            >
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={4} rowCount={6} />}

          {!isLoading &&
            items.length > 0 &&
            items.map((item) => {
              const fechaOrden = parseISO(item.fecha);
              const fechaText = format(fechaOrden, "dd/MM/yy hh:mm a"); //yyyy-MMM-dd HH:mm:ss");

              const idRaw = item.id;
              const ordenVentaId = item.ordenVenta?.id ?? "-";
              const usuarioCreador = buildName(item.usuarioCreador, true);

              const orderVenta = item.ordenVenta;

              const asociado = orderVenta.asociado
                ? buildName(orderVenta.asociado, true)
                : "-";
              const cliente = orderVenta.cliente
                ? buildName(orderVenta.cliente, true)
                : "-";

              let tipo = item?.tipoDeSolicitud ?? "";
              const tipoName = {
                OrdenVentaCancelada: { name: "Cancelar" },
                OrdenVentaDevolucion: { name: "Devolución" },
              };
              tipo = tipoName[tipo]?.name ?? "";
              //  const creador = buildName(item.usuarioCreador, true);

              //  const item = value.asociado;
              //const nombre = buildName(item, true);

              //  const totalPagar = Singleton.getInstance().format(item.credito);

              //const nombre = buildName(item, true);

              return (
                <tr key={item.id}>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a href="#" onClick={(e) => openItem(item)}>
                      {fechaText}
                    </a>
                  </th>
                  <td>
                    <a
                      href="#"
                      className="text-primary"
                      onClick={(e) => openItem(item)}
                    >
                      <div className="container text-left">
                        <div className="row">
                          <div className="p-0">
                            <span>
                              <b>Id: </b>
                            </span>
                            {idRaw}
                          </div>
                          <div className="p-0">
                            <span>
                              <b>Orden Venta Id: </b>
                            </span>
                            {ordenVentaId}
                          </div>
                          <div className="p-0">
                            <span>
                              <b>Cliente: </b>
                            </span>
                            {cliente}
                          </div>
                          <div className="p-0">
                            <span>
                              <b>Asociado: </b>
                            </span>
                            {asociado}
                          </div>
                          <div className="p-0">
                            <span>
                              <b>Solicitado: </b>
                            </span>
                            {usuarioCreador}
                          </div>
                        </div>
                      </div>
                    </a>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <div className="row">
                      <b>A:</b>
                    </div>
                    <div className="row" style={{ justifyContent: "center" }}>
                      {tipo}
                    </div>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <button
                      type="button"
                      className={`btn btn-sm btn-warning`}
                      style={{ margin: "0px" }}
                      onClick={(e) => tryApprove1(item)}
                    >
                      Revisar
                    </button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
